import { SVGProps } from 'react';

const PlugZap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2 22 3-3m2.5-5.5L10 11m.5 5.5L13 14m5-11-4 4h6l-4 4m-9.7 9.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4z"
    />
  </svg>
);
export default PlugZap;
